<div class="table-responsive">
  <table class="table table-bordered table-striped table-hover mb-0">
    <thead class="table-light">
      <tr>
        <th>#</th>
        <th>Formato</th>
        <th>Región</th>
        <th>Autor</th>
        <th>Fecha</th>
        @if (showSourceBadge()) {
          <th>Origen</th>
        }
        <th class="text-center align-middle" style="width: 60px">Acción</th>
      </tr>
    </thead>
    <tbody>
      @for (entry of entries(); track $index) {
        @let org = getOrganizacion(entry);
        <tr style="cursor: pointer" (click)="detalleClick.emit(entry)">
          <td>{{ $index + 1 }}</td>
          <td>{{ entry.resource?.title || 'RDA' }}</td>
          <td>{{ getRegion(org) }}</td>
          <td>{{ org?.name || 'N/A' }}</td>
          <td>{{ formatDate(entry.resource?.date || entry.resource?.meta?.lastUpdated) }}</td>
          @if (showSourceBadge()) {
            @let badge = getSourceBadge(entry._source || '');
            <td>
              <span class="badge {{ badge.color }}"> {{ badge.icon }} {{ badge.label }} </span>
            </td>
          }
          <td class="text-center align-middle">
            <button
              class="eye-btn"
              title="Ver detalle"
              (click)="detalleClick.emit(entry); $event.stopPropagation()"
            >
              <i class="bx bx-show"></i>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
